import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { ProjectRoleService } from '../../../services/project-role.service';

export const testPlanEditBreadcrumbResolver: ResolveFn<string> = (route) => {
  const roles = inject(ProjectRoleService);
  const projectId = route.pathFromRoot.map((r) => r.paramMap.get('projectId')).find(Boolean) ?? null;
  return roles
    .ensureLoaded(projectId)
    .pipe(
      map(() =>
        roles.isProjectReader() && !roles.isTenantAdmin()
          ? 'header.breadcrumb.testPlanView'
          : 'header.breadcrumb.testPlanEdit',
      ),
    );
};
